// Duration analysis
// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import EnergyTreeNodeDurationAnalysisPage from '@/features/energyxplorer/components/analysis/EnergyTreeNodeDurationAnalysisPage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/duration-analysis',
)({
  component: EnergyTreeNodeDurationAnalysisPage,
  staticData: { crumb: 'energyxplorer:app_bar.energy_analysis_duration' },
});
